export default __webpack_public_path__ + "assets/gatedCommunity.cccb23d9.svg";